import React from 'react'
import { ErrorMessages } from './ErrorCodes'

export default function Error( {code}) {
  
  return (
    <div className="text-danger doc-error-message" >
        <img src="https://secureimages.mcafee.com/common/affiliateImages/Docomo_MMA/error-icon-sm.png" alt="Error Icon" className='doc-error-icon'/>
        <span dangerouslySetInnerHTML={{ __html: ErrorMessages[code] }} /> ({code})
    </div>
  )
}
